import axios from 'axios';
import useSWR from 'swr';

import { getApiUrl, formatAndThrowApiError, getTenantId } from '@/helpers/api';

export const useTenant = () => {
  const urlStr = `${getApiUrl()}/admin/tenant?${getTenantId()}`;
  const swr = useSWR(
    urlStr,
    async (url) => {
      try {
        const result = await axios.get(url);
        return result.data;
      } catch (err) {
        formatAndThrowApiError(err);
      }
    },
    {
      dedupingInterval: 60000, // 60 seconds
      revalidateOnFocus: false,
      revalidateOnReconnect: false
    }
  );
  return swr;
};
